namespace Areas.Maintenance {
    "use strict";

    export function disableColumnEdit(columnName: string) {
        return (e: any) => {
            if (e.rowType !== "data" || !e.row.isEditing)
                return;
            if (e.column.dataField === columnName && !e.row.inserted)
                e.cellElement.find("input").prop("readonly", true);
        }
    }
}
